import React from "react";
import BaseComponent from "../BaseComponent";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";

import Button from "../Nano/Buttons/Button.js";
import Spinner from "../Nano/Spinner.js";
import Type from "../Global/Typography.js";
import UpdateSavedSearchModal from "../Micro/UpdateSavedSearchModal.js";
import CreateSavedSearchModal from "../Micro/CreateSavedSearchModal.js";

import { ReactComponent as SavedSearch } from "../Global/Icons/savedSearches.svg";

const multiple = nota.global.multiple;

const SavedSearchModalStyle = styled.div`
  width: 350px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: ${multiple * 3 + "px"};
  .headerModal {
    padding-bottom: ${multiple + "px"};
    border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
    svg {
      height: 16px;
      width: 16px;
      path {
        fill: ${nota.color.main.default};
      }
    }
    h3 {
      margin-left: ${multiple + "px"};
      text-transform: uppercase;
      b {
        color: ${nota.color.main.default};
      }
    }
  }
  .modalContainer {
    .modalWrapper {
      padding: ${multiple * 3 + "px"} 0;
    }
  }

  .modalBtnWrapper {
    margin-bottom: ${multiple * 2 + "px"};
    padding: ${multiple + "px"};
    background-color: ${nota.color.main.default};
    cursor: pointer;
    h4 {
      color: ${nota.color.neutral.white};
      text-transform: uppercase;
    }
    &:hover {
      opacity: 0.7;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .btnsContainer {
    padding: 16px 8px 0 8px;
    border-top: 0.5px solid ${nota.color.neutral.NeuFour};
  }

  .dropDownWrapper {
    .dropdown-content {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    width: 90vw;
  }
`;

class SavedSearchModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      loading: true,
      canUpdateSavedSearch: true,
      openUpdateSavedSearch: false,
      openCreateNewSavedSearch: false,
    };
  };

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate(prevProps, prevState) {}

  componentWillUnmount() {
    super.componentDidMount();
  }

  savedSearchLoadAction = (data) => {
    let canUpdateSavedSearch = data && data.length > 0;
    this.setState({ loading: false, canUpdateSavedSearch: canUpdateSavedSearch, openCreateNewSavedSearch: !canUpdateSavedSearch ? true : this.state.openCreateNewSavedSearch });
  };

  openUpdateSavedSearch = () => {
    this.setState({ openUpdateSavedSearch: true });
  };

  openCreateNewSavedSearch = () => {
    this.setState({ openCreateNewSavedSearch: true });
  };

  cancelCreateSavedSearch = () => {
    if (this.state.canUpdateSavedSearch == false) {
      this.cancelSavedSearchModal();
    } else {
      this.setState({ openCreateNewSavedSearch: false });
    }
  };

  nextCreateSavedSearch = (data) => {
    this.setState({ openCreateNewSavedSearch: false, canUpdateSavedSearch: true }, () => {
      this.props.nextAction();
    });
  };

  cancelUpdateSavedSearch = () => {
    this.setState({ openUpdateSavedSearch: false });
  };

  nextUpdateSavedSearch = (data) => {
    this.setState({ openUpdateSavedSearch: false }, () => {
      this.props.nextAction();
    });
  };

  cancelSavedSearchModal = () => {
    this.props.cancelAction();
  };

  render() {
    let openCreate = this.state.openCreateNewSavedSearch || this.state.canUpdateSavedSearch == false;
    let openAdd = this.state.openUpdateSavedSearch;
    return (
      <NanoFlex>
        <SavedSearchModalStyle style={openCreate || openAdd ? { display: "none" } : {}}>
          <NanoFlex className="headerModal" justifyContent="flex-start">
            <SavedSearch />
            <Type.h3>
              <b>{this.translation.savedSearch.title}</b>
            </Type.h3>
          </NanoFlex>

          {this.state.loading && <Spinner />}
          {!this.state.loading && (
            <NanoFlex className="modalContainer" flexDirection={"column"} justifyContent="space-between" alignContent="space-between">
              <NanoFlex className="modalWrapper" flexDirection={"column"}>
                <NanoFlex className="modalBtnWrapper" onClick={this.openUpdateSavedSearch}>
                  <Type.h4>{this.translation.savedSearch.updateSavedSearch}</Type.h4>
                </NanoFlex>
                <NanoFlex className="modalBtnWrapper" onClick={this.openCreateNewSavedSearch}>
                  <Type.h4>{this.translation.savedSearch.createNewSavedSearch}</Type.h4>
                </NanoFlex>
              </NanoFlex>

              <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
                <Button label={this.translation.geral.cancel} simple clickAction={this.cancelSavedSearchModal} />
              </NanoFlex>
            </NanoFlex>
          )}
        </SavedSearchModalStyle>
        <NanoFlex style={!openCreate ? { display: "none" } : {}}>
          <CreateSavedSearchModal filter={this.props.filter} cancelAction={this.cancelCreateSavedSearch} nextAction={this.nextCreateSavedSearch} />
        </NanoFlex>
        <NanoFlex style={!openAdd ? { display: "none" } : {}}>
          <UpdateSavedSearchModal visible={this.props.visible} filter={this.props.filter} savedSearchLoadAction={this.savedSearchLoadAction} cancelAction={this.cancelUpdateSavedSearch} nextAction={this.nextUpdateSavedSearch} />
        </NanoFlex>
      </NanoFlex>
    );
  }
}

// Set default props
SavedSearchModal.defaultProps = {
  cancelAction: () => null,
  nextAction: () => null,
};

export default SavedSearchModal;

/*
Doc
import SavedSearchModal from '../../Micro/SavedSearchModal.js';

<SavedSearchModal
    cancelAction={() => console.log('cancelAction')}
    nextAction={() => console.log('nextAction')}
/>
*/
